import { Switch } from '@mantine/core';

interface MapSwitchProps {
  isChecked: boolean;
  onChange: (checked: boolean) => void;
  testId?: string;
}

export const MapSwitch = ({ isChecked, onChange, testId }: MapSwitchProps) => (
  <Switch
    checked={isChecked}
    onChange={(e) => onChange(e.currentTarget.checked)}
    data-testid={testId}
    styles={{ body: { gap: 'unset' } }}
  />
);
